import Grid from '@material-ui/core/Grid'
import React, { Component } from 'react'
import { getCardEnableData, getEMPI, getMyneedsEOS, getMyneedsEOSnew } from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import ChatIcon from '../../WebScreen/ChatBox/ChatIcon'
import MobCopyright from '../MobCopyright'
import { Tab, Tabs } from '@material-ui/core'
import MyNeedsSimpleAccordion from '../MobileCommonComponents/myneedsAccordion'
import MobileHeader from '../MobileHeader'
import customStyle from '../../WebScreen/programInfo/CSS/stylesheet_UHS'
import { withStyles } from '@material-ui/styles'
import MobileFooter from './../MobileFooter'
import ContributionmyneedsAccordion from '../MobileCommonComponents/ContributionmyneedsAccordion'
import ContributionAccordian from '../MobileCommonComponents/ContributionAccordion'
import Modal1 from 'react-awesome-modal'
import ReimbursementDataTable from '../../WebScreen/ReimbursementDataTable'
import apiService from '../../../utils/apiservice'

const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

export default class MyNeedsMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      sampleData: [],
      response: [],
      formatedjsonData: null,
      page: 0,
      loader: true,
      loadMoreBtnshow: false,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '',
      tabEnable: localStorage.getItem("isAdmin") ? true: false,
      selectedTab:"MyShareRequests",
      showReimbursementFormInTab: false,
      selectedRowData: null,
      familyMembers: []
    }
  }

  componentDidMount() {
    this.getCardEnable()
    this.getEMPID()
    this.callapi()
    // Listen for reimbursement form completion event from iframe using postMessage
    window.addEventListener("message", this.handleReimbursementComplete)
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener("message", this.handleReimbursementComplete)
  }

  handleReimbursementComplete = (event) => {
    // Check if the message is from the reimbursement iframe
    if (event.data?.type === "memberReimbursementRequestComplete") {
      const eventData = event.data?.data || {}
      
      // Check if the event contains error information
      if (event.data?.error || event.data?.status === 'error') {
        console.error('Reimbursement request error:', eventData)
        // Handle error case - perform back button function
        this.goBack()
      } else {
        // Handle success case - perform back button function
        console.log('Reimbursement request completed successfully:', eventData)
        this.goBack()
      }
    }
  }

  getEMPID() {
    getEMPI().then(res => {
      console.log('=============getEMPI===========', res)
    })
  }

  callapi() {
    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============MY needs data mobile===========', res.data)
      if (res.data.length > 0) {
        this.setState({ response: res.data, loader: false })
      } else {
        this.setState({
          notfoundmsg1:
            'No needs have been entered into the system. Submitted needs may take 2-3 days to be displayed here. For any clarifications call Customer Service.',
          loader: false
        })
      }

      if (res.data.length > 10) {
        this.setState({ loadMoreBtnshow: true })
      }
      this.setState({ response: res.data, page: this.state.page + 1, loader: false })
      this.createjson()
    })
  }

  callapiLoadmore() {
    this.setState({ loader: true })

    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============TRansaction data mobile===========', res.data)
      console.log('my loade more res===', res)
      var resnew = res.data
      var data = this.state.response
      var newdata = data.concat(resnew)

      console.log('new data loade more is==', newdata)

      if (res.data.totalrecords === newdata.length) {
        this.setState({ loadMoreBtnshow: false })
      }
      this.setState({ response: newdata, loader: false, page: this.state.page + 1 })
      this.createjson()
    })
  }

  getCardEnable = () => {
    let client_id = localStorage.getItem('CLIENT_ID')

    getCardEnableData(client_id, 'MyNeeds').then(res => {
      console.log('getCardEnableData=====', res.data.response.enable)

      if (res.data.response.enable == 'false' || res.data.response.enable == false) {
        window.location.href = '/'
      }
    })
  }

  getFamilyMembers = () => {
    let email = localStorage.getItem('userMail')
    if (!email) {
      console.log('Email not found in localStorage')
      return
    }
    
    const request = { email: email }
    apiService.post(process.env.REACT_APP_BASE_URL + 'v2/memberportal/idcard', request)
      .then(res => {
        if (res?.data?.memberIdCardList && Array.isArray(res.data.memberIdCardList)) {
          // Extract family member names from memberIdCardList
          const members = res.data.memberIdCardList.map(member => ({
            memberId: member.empId,
            firstName: member.firstName || '',
            middleName: member.middleName || '',
            lastName: member.lastName || '',
            prefix: member.prefix || '',
            suffix: member.suffix || '',
            fullName: `${member.prefix || ''} ${member.firstName || ''} ${member.middleName || ''} ${member.lastName || ''} ${member.suffix || ''}`.trim().replace(/\s+/g, ' ')
          }))
          this.setState({ familyMembers: members })
        }
      })
      .catch(err => {
        console.error('Error fetching family members:', err)
      })
  }

  goBack = () => {
    if (this.state.showReimbursementFormInTab) {
      this.closeReimbursementForm()
    } else {
      this.props.history.push('/')
    }
  }

  getEncodedMemberData = () => {
    // Get member data from localStorage or state
    const memberData = {
      phone: localStorage.getItem('phone') || "",
      memberId: localStorage.getItem('EMPID') || "",
      email: localStorage.getItem('userMail') || "",
      initiatedUser: localStorage.getItem('userMail') || "",
      source: "MemberPortal",
      userRole: "USER",
      type: "Reimbursement",
      client: "UHF",
      memberName: localStorage.getItem('subscriberName') || "",
      requestId: this.state.selectedRowData?.id || "",
      familyMembers: this.state.familyMembers
    }
    
    // Convert to JSON string and encode to base64
    const jsonString = JSON.stringify(memberData)
    const encodedData = btoa(jsonString)
    return encodedData
  }

  openReimbursementForm = (rowData = null) => {
    this.setState({ 
      selectedTab: "MyReimbursementRequests",
      showReimbursementFormInTab: true,
      selectedRowData: rowData
    })
    // Fetch family members when opening the form
    this.getFamilyMembers()
  }

  closeReimbursementForm = () => {
    this.setState({ showReimbursementFormInTab: false })
  }
  combineDate = (x, y) => {
    if (x == y) {
      return x
    }

    const z = x + '-' + y
    return z
  }
  createjson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      newobject.ExpenseNumberLabel = 'Expense Number'
      newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.start_of_service_date, item.end_date_of_service),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Allowed Amount',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),
        
        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        PendingReasonLabel: 'Pending Reason',
        PendingReasonVal: item.pend_reason || 'N/A',
        // SharedByUHFLabel: 'Shared By UHF',
        // SharedByUHFVal: '$' + item.paid_amount
      }
      
      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat({...newobject, ...item})
    })

    this.setState({ formatedjsonData: formatredjson })
  }
  Contributioncreatejson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      // newobject.ExpenseNumberLabel = 'Reference #'
      // newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged Amount'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid Amount'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.service_date),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Eligible for Sharing',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),

        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        PendingReasonLabel: 'Pending Reason',
        PendingReasonVal: item.pend_reason || 'N/A',

        paidDateLabel: '	Paid Date',
        paidDateVal: item.date_paid,
        RepricedAmountLabel:"Repriced Amount",
        RepricedAmountVal: "$"+item.repricing_amount,
        MCPVLabel:`Visit Fees\n (MCP)`,
        MCVPValue: "$0.00",
        MCPLabel:"Member Commitment Portion (MCP)",
        MCPvalue:"$"+item.mcp,
        ShareableAmountLabel:"Shareable Amount",
        ShareableAmountValue:"$0.00",

        // SharedByUHFLabel: 'Paid Amount',
        // SharedByUHFVal: '$' + item.paid_amount
      }

      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat(newobject)
    })

    this.setState({ formatedjsonData: formatredjson })
  }

  render() {
    const { formatedjsonData } = this.state
    return (
      <div className="">
        {this.state.loader ? <CommonLoader /> : null}
        <MobileHeader name="Back" onBackClick={this.goBack} />
        {!this.state.showReimbursementFormInTab && this.state.tabEnable && <AntTabs
                  value={this.state.selectedTab}
                  onChange={(e, newValue) => this.setState({selectedTab: newValue})}
                  textColor="#33333"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                  id="tabs"
                  style={{ width: '100%',height:'auto',marginTop: 60}}
                >
                  <Tab label="MY NEEDS" value="MyShareRequests" style={{ textTransform: 'capitalize',width:'13%',marginTop:window.mobileAndTabletCheck()? "28px":"10px",fontSize:"4vw",color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e' }} />
                  <Tab label="MY CONTRIBUTIONS" value="MyCONTRIBUTIONS" style={{ textTransform: 'capitalize',width:'20%',margin:window.mobileAndTabletCheck()? "40px 0px 4px 0px":"10px 0px 0px 0px",fontSize:"4vw",color: this.state.selectedTab == 'MyCONTRIBUTIONS' ? '#000' : '#7e7e7e'  }} />
                  <Tab label="MY REIMBURSEMENT REQUESTS" value="MyReimbursementRequests" style={{ textTransform: 'capitalize',width:'25%',margin:window.mobileAndTabletCheck()? "40px 0px 4px 0px":"10px 0px 0px 0px",fontSize:"4vw",color: this.state.selectedTab == 'MyReimbursementRequests' ? '#000' : '#7e7e7e'  }} />
          </AntTabs>}
        {!this.state.showReimbursementFormInTab && !this.state.tabEnable && <AntTabs
                  value={this.state.selectedTab}
                  onChange={(e, newValue) => this.setState({selectedTab: newValue})}
                  textColor="#33333"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                  id="tabs"
                  style={{ width: '100%',height:'auto',marginTop: 60}}
                >
                  <Tab label="MY NEEDS" value="MyShareRequests" style={{ textTransform: 'capitalize',fontSize:"4vw",color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e' }} />
                  <Tab label="MY REIMBURSEMENT REQUESTS" value="MyReimbursementRequests" style={{ textTransform: 'capitalize',fontSize:"4vw",color: this.state.selectedTab == 'MyReimbursementRequests' ? '#000' : '#7e7e7e'  }} />
          </AntTabs>}

        {this.state.showReimbursementFormInTab ? (
          <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 250px)', backgroundColor: 'white', marginTop: '58px' }}>
            <iframe
              src={`${process.env.REACT_APP_PLUGIN}MemberReimbursementRequest/${this.getEncodedMemberData()}`}
              style={{
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              title="Reimbursement Form"
            />
          </div>
        ) : (
          <>
            {this.state.selectedTab === "MyReimbursementRequests" ?
              <div className="mobileCommonBody" style={{ marginBottom: '0px' }}>
                <ReimbursementDataTable onUpdateClick={(rowData) => this.openReimbursementForm(rowData)}/>
              </div>
            : this.state.formatedjsonData ? (
              <div className={this.state.tabEnable ?"mobileCommonBodyContribution":"mobileCommonBody"} style={{ marginBottom: '0px' }}>
                <div>
                {this.state.tabEnable && this.state.selectedTab === "MyShareRequests" ?
                      <ContributionmyneedsAccordion data={formatedjsonData}/>
                      : !this.state.tabEnable && <MyNeedsSimpleAccordion data={formatedjsonData} />}
                      {this.state.tabEnable && this.state.selectedTab === "MyCONTRIBUTIONS" &&
                      <ContributionAccordian/>}

                  {this.state.loadMoreBtnshow ? (
                    <div className="loadMoreWrapper">
                    {!this.state.tabEnable &&  <button className="loadMoreBtn" onClick={() => this.callapiLoadmore()}>
                        Load More
                      </button>}
                    </div>
                  ) : null}

                  {this.state.selectedTab !== "MyCONTRIBUTIONS" && this.state.notfoundmsg1 == '' ? (
                    <Grid container style={{ padding: '10px', backgroundColor: 'white' }}>
                      <span style={{ fontStyle: 'Roboto', fontWeight: '500' }}>
                        **For complete status, please refer to the Explanation of Sharing (EOS) mailed to your address on file
                      </span>
                    </Grid>
                  ) : null}
                </div>

                {this.state.notfoundmsg1 == '' ? null : (
                  this.state.selectedTab !== "MyCONTRIBUTIONS" &&
                  <div style={{ padding: '180px 0px', textAlign: 'center' }} className="mobile_data_not_found">
                    {this.state.notfoundmsg1}
                  </div>
                )}
              </div>
            ) : null}
          </>
        )}

        {/* {this.state.loader ? null : (
          <div style={{ bottom: '9vh', position: 'fixed', display: 'flex', flexDirection: 'column' }}>
            <ChatIcon showAIChatIcon={true} />
            <div >
              <ChatIcon />
            </div>
            <div style={{ bottom: '9vh', position: 'fixed' }}>
              <MobCopyright />
            </div>
          </div>
        )} */}
        {/* <MobileFooter /> */}
        {/* <div class="fixed-bottom">
          <MobileFooter name="My Needs" />
        </div> */}
        {this.state.loader ? null : (
          <div>
            <div style={{ bottom: '6vh', top: 10, position: 'relative', padding: '12px' }}>
              {!this.state.showReimbursementFormInTab && (
                <button 
                  type="button" 
                  className="myNeedsReimbursementBtn" 
                  onClick={() => this.openReimbursementForm()}
                  style={{
                    width: '100%',
                    maxWidth: '280px',
                    padding: '12px 24px',
                    border: '2px solid #2e3192',
                    borderRadius: '50px',
                    backgroundColor: 'transparent',
                    color: '#2e3192',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    marginBottom: '12px',
                    display: 'block',
                    margin: '0 auto 12px'
                  }}
                >
                  REIMBURSEMENT REQUEST
                </button>
              )}
              <ChatIcon showAIChatIcon={true} />
              <ChatIcon setAI={() => this.setState({ isAI: true })} />
              <MobCopyright />
            </div>
        
            <div class="fixed-bottom">
              <MobileFooter name="My Needs"/>
            </div>
      
          </div>
        )}

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">
              This service is currently offline. Please try again later.
            </div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
}

const sampleData2 = [
  { id: 733, planId: '7006', idcardField: 'Telemedicine', fieldValue: '$0' },
  { id: 735, planId: '7006', idcardField: 'PCP Office Visit', fieldValue: '$35' },
  { id: 736, planId: '7006', idcardField: 'Urgent Care', fieldValue: '$100' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' }
]
const sampleData = [
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  }
]
